module.exports = __webpack_public_path__ + "static/media/foot-left-back.58ff03bb.png";